import { CropMap } from "../../pages/map-page/shared/dtos/arcgis-map-crop-props.dto";

export type ArcGisError = {
  code: number;
  details: string[];
  message: string;
};

export function isArcGisError(list: CropMap | ArcGisError): list is ArcGisError {
  return (list as ArcGisError).code !== undefined;
}
